/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Pm_Card_BodyInputs */

const cs_pm_card_body = /** @type {(inputs: Pm_Card_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Chybí u nemovitostí ID inzerátu na portálu? Průvodce načte inzeráty z portálu, navrhne páry podle adresy, GPS, ceny, plochy, dispozice, názvu a fotek a vy je potvrdíte.`)
};

const en_pm_card_body = /** @type {(inputs: Pm_Card_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Properties missing their portal listing ID? The wizard loads the portal's listings, proposes pairs by address, GPS, price, area, layout, title and photos, and you confirm them.`)
};

/**
* | output |
* | --- |
* | "Properties missing their portal listing ID? The wizard loads the portal's listings, proposes pairs by address, GPS, price, area, layout, title and photos, an..." |
*
* @param {Pm_Card_BodyInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const pm_card_body = /** @type {((inputs?: Pm_Card_BodyInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Pm_Card_BodyInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_pm_card_body(inputs)
	return cs_pm_card_body(inputs)
});